module.exports = __webpack_public_path__ + "static/img/fa-regular-400.20af3d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.svg
// module id = gNJU
// module chunks = 0